// stores/notificationStore.js
//
// Pinia store for notification center state (Task 5 — Phase 1b).
//
// Persists: unreadCount only (via pinia-plugin-persistedstate).
// Cold-boot note: persisted unreadCount may be briefly stale before the first
// background refresh resolves. Server meta.unreadCount is authoritative on
// every list or unread-count fetch — call setUnreadCount() to reconcile.
// (deferred-work.md 2026-05-21)
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNotificationStore = defineStore(
  'notifications',
  () => {
    // Persisted: badge count survives cold boot.
    // May be briefly stale before the first background fetch reconciles it.
    const unreadCount = ref(0);

    // Transient: loading state for UI spinners (not persisted).
    const isLoading = ref(false);

    function setUnreadCount(count) {
      unreadCount.value = Math.max(0, Number(count) || 0);
    }

    function decrementUnread(by = 1) {
      unreadCount.value = Math.max(0, unreadCount.value - by);
    }

    function clearUnread() {
      unreadCount.value = 0;
    }

    return {
      unreadCount,
      isLoading,
      setUnreadCount,
      decrementUnread,
      clearUnread,
    };
  },
  {
    // Persist only unreadCount so the badge survives cold boot.
    // pinia-plugin-persistedstate is already wired in src/plugins/piniaPlugin.js.
    persist: {
      key: 'poolit:notifications',
      pick: ['unreadCount'],
    },
  },
);
